import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { vehicleTransferService } from '../../../services/vehicleTransferService';
import { APPROVALS_CHANGED_EVENT } from '../../../components/awaitingApprovalsCount';
import { PILL_SHELL, STATUS_TONES } from '../../../components/ui/pillStyles';

const LINKS = [
  { to: '/equipment', label: 'Fleet', end: true },
  { to: '/equipment/board', label: 'Shop Board', end: true },
  { to: '/equipment/dashboard', label: 'Dashboard', end: true },
  { to: '/equipment/transfers', label: 'Transfers', end: false }
];

/**
 * V3-059: the Transfers tab shows how many transfers need the user's action (the same count as
 * the Needs My Action view), refreshed when an approval changes. Nothing shows at 0.
 */
function useNeedsMyActionCount(): number {
  const [count, setCount] = useState(0);
  useEffect(() => {
    let cancelled = false;
    const load = () =>
      vehicleTransferService
        .awaitingCount()
        .then((n) => !cancelled && setCount(n))
        .catch(() => !cancelled && setCount(0));
    load();
    window.addEventListener(APPROVALS_CHANGED_EVENT, load);
    return () => {
      cancelled = true;
      window.removeEventListener(APPROVALS_CHANGED_EVENT, load);
    };
  }, []);
  return count;
}

const EquipmentSubnav: React.FC = () => {
  const needsMyAction = useNeedsMyActionCount();
  return (
    <nav aria-label="Equipment sections" className="tw-mb-4 tw-flex tw-flex-wrap tw-gap-1 tw-border-b tw-border-line">
      {LINKS.map((link) => (
        <NavLink
          key={link.to}
          to={link.to}
          end={link.end}
          className={({ isActive }) =>
            `-tw-mb-px tw-border-b-2 tw-px-3 tw-py-2 tw-text-sm tw-no-underline ${
              isActive
                ? 'tw-border-primary tw-font-medium tw-text-primary'
                : 'tw-border-transparent tw-text-content-secondary hover:tw-text-content'
            }`
          }
        >
          {link.label}
          {link.to === '/equipment/transfers' && needsMyAction > 0 && (
            <span
              className={`tw-ml-1.5 tw-justify-center ${PILL_SHELL} ${STATUS_TONES.warning}`}
              aria-label={`${needsMyAction} need${needsMyAction === 1 ? 's' : ''} my action`}
              title="Needs My Action"
            >
              {needsMyAction}
            </span>
          )}
        </NavLink>
      ))}
    </nav>
  );
};

export default EquipmentSubnav;
